import { render, staticRenderFns } from "./FavoriteRoleItem.vue?vue&type=template&id=026078ae&scoped=true&"
import script from "./FavoriteRoleItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteRoleItem.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteRoleItem.vue?vue&type=style&index=0&id=026078ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026078ae",
  null
  
)

export default component.exports